// allow enable/disable of usage tracking from non-dismissable notice
jQuery( function() {
	jQuery('.wpmdb-opt-usage-tracking').on( 'click', function(e) {
		e.preventDefault();
		var optIn = e.target.classList.contains('opt-yes') ? true : false

		jQuery('.wpmdb-usage-tracking-notice .links').text( (optIn) ? "Thanks!" : "Done." );
		jQuery('.wpmdb-usage-tracking-notice').delay(1000).fadeOut(200);

		var $switch = jQuery('#allow_tracking-wrap');
		if( optIn ) {
			if( ! $switch.hasClass('on') ) {
				$switch.trigger('click');
				return;
			}
		} else {
			if( $switch.hasClass('on') ) {
				$switch.trigger('click');
				return;
			}
		}
		$switch.find('input[type=checkbox]').trigger('change');
	} );
});



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro/asset/src/js/usage-tracking-notice.js